import './index.scss';

import { Fancybox } from "@fancyapps/ui";

// Borra el import de jQuery y usa el global de la ventana
const $ = window.jQuery;

/**
 * 1. Función para el Header Sticky
 */
const initHeader = () => {
    const header = document.querySelector('.site-header');
    if (!header) return;

    let isScrolling = false;

    window.addEventListener('scroll', () => {
        if (!isScrolling) {
            window.requestAnimationFrame(() => {
                header.classList.toggle('fixed', window.scrollY > 50);
                isScrolling = false;
            });
            isScrolling = true;
        }
    }, { passive: true });
};

/**
 * 2. Función para el Menú Responsive
 */
const initNavigation = () => {
    const button = document.querySelector('.menu-toggle');
    const menu = document.querySelector('.menu-container');

    if (!button || !menu) return;

    button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !expanded);
        menu.classList.toggle('is-open');
        document.body.classList.toggle('no-scroll');
    });
};

/**
 * 3. Gravity Forms: Auto-avance y Seguimiento GTM
 */
const initGravityForms = () => {
    // Escucha el avance automático de páginas
    $(document).on('change', '.gf_auto_advance .gfield_radio input[type="radio"]', function() {
        const $currentPage = $(this).closest('.gform_page');
        const $nextButton = $currentPage.find('.gform_next_button');

        if ($nextButton.length > 0) {
            setTimeout(() => {
                $nextButton.trigger('click');
            }, 250);
        }
    });

    // ESCUCHA EL EVENTO DE ÉXITO (GTM + WPML)
    $(document).on('gform_confirmation_loaded', function(event, formId) {
        // 1. Detectamos el idioma configurado por WPML en la etiqueta <html lang="...">
        const currentLang = document.documentElement.lang || 'es';

        window.dataLayer = window.dataLayer || [];

        // 2. Enviamos el evento con los nuevos datos de diferenciación
        window.dataLayer.push({
            'event': 'formulario_completado',
            'form_id': formId,               // Diferencia cuál de los 3 formularios es
            'form_language': currentLang      // Diferencia el idioma (ej: "es-ES", "en-GB")
        });

        console.log(`GTM: Evento enviado. ID: ${formId} | Idioma: ${currentLang}`);

    });
};

/**
 * 4. Cards Home -> Preseleccionar opción del formulario principal
 */
const initHomeFormCards = () => {
    const formUrl = '/calcular-tu-hipoteca/';

    const options = [
        {
            className: 'hn-op-primera-vivienda',
            radioId: 'choice_1_3_0'
        },
        {
            className: 'hn-op-vivienda-elegida',
            radioId: 'choice_1_3_0'
        },
        {
            className: 'hn-op-mejorar-hipoteca',
            radioId: 'choice_1_3_2'
        },
        {
            className: 'hn-op-mas-financiacion',
            radioId: 'choice_1_3_3'
        }
    ];

    const getOptionFromElement = (element) => {
        if (!element) return null;

        return options.find((option) => {
            return element.closest(`.${option.className}`);
        });
    };

    options.forEach((option) => {
        document.querySelectorAll(`.${option.className}`).forEach((card) => {
            card.classList.add('hn-home-option-card');
            card.setAttribute('role', 'button');
            card.setAttribute('tabindex', '0');
            card.setAttribute('aria-label', 'Ir al formulario de hipoteca');
        });
    });

    document.addEventListener('click', (event) => {
        const option = getOptionFromElement(event.target);

        if (!option) return;

        sessionStorage.setItem('hn_selected_radio_id', option.radioId);
        window.location.href = formUrl;
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const option = getOptionFromElement(event.target);

        if (!option) return;

        event.preventDefault();

        sessionStorage.setItem('hn_selected_radio_id', option.radioId);
        window.location.href = formUrl;
    });
};

/**
 * 5. Página formulario -> marcar radio guardado desde la Home
 */
const initPreselectGravityRadio = () => {
    const selectedRadioId = sessionStorage.getItem('hn_selected_radio_id');

    if (!selectedRadioId) return;

    const selectRadio = () => {
        const radio = document.getElementById(selectedRadioId);

        if (!radio) return false;

        if (radio.disabled) {
            radio.disabled = false;
        }

        radio.checked = true;

        radio.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        }));

        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));

        const label = document.querySelector(`label[for="${selectedRadioId}"]`);

        if (label) {
            label.classList.add('is-selected-from-home');
        }

        sessionStorage.removeItem('hn_selected_radio_id');

        return true;
    };

    if (selectRadio()) return;

    let attempts = 0;

    const interval = setInterval(() => {
        attempts++;

        if (selectRadio() || attempts > 40) {
            clearInterval(interval);
        }
    }, 250);
};

/**
 * 6. Calculadora de Hipoteca (Gravity Forms Moderno)
 */
const initCalculadoraHipoteca = () => {

    /**
     * Convierte números en formato español / moneda a número real.
     *
     * Ejemplos:
     * 456.456,00 € -> 456456
     * 456.456      -> 456456
     * 456,50       -> 456.5
     * 100000000    -> 100000000
     */
    const parseNumeroES = (value) => {
        if (value === undefined || value === null) return 0;

        let valor = value.toString().trim();

        if (valor === "") return 0;

        valor = valor.replace(/[^\d.,-]/g, "");

        if (valor === "" || valor === "-" || valor === "," || valor === ".") return 0;

        if (valor.includes(",") && valor.includes(".")) {
            // Formato español: 456.456,00
            valor = valor.replace(/\./g, "").replace(",", ".");
        } else if (valor.includes(",")) {
            const partes = valor.split(",");
            const decimalPart = partes[1] || "";

            // Si tiene 3 dígitos después de la coma, lo tratamos como millares:
            // 456,456 -> 456456
            if (decimalPart.length === 3) {
                valor = valor.replace(/,/g, "");
            } else {
                valor = valor.replace(",", ".");
            }
        } else if (valor.includes(".")) {
            const partes = valor.split(".");
            const lastPart = partes[partes.length - 1];

            // 456.456 -> 456456
            if (lastPart.length === 3) {
                valor = valor.replace(/\./g, "");
            }
        }

        const n = parseFloat(valor);
        return isNaN(n) ? 0 : n;
    };

    /**
     * Formatea un valor a moneda española.
     *
     * Ejemplo:
     * 456456 -> 456.456,00 €
     */
    const formatMonedaES = (value) => {
        const numero = typeof value === "number" ? value : parseNumeroES(value);

        if (isNaN(numero)) return "";

        return numero.toLocaleString("es-ES", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + " €";
    };

    /**
     * Función auxiliar para extraer números limpios de los inputs.
     */
    const getVal = (selector) => {
        return parseNumeroES($(selector).val());
    };

    /**
     * Limitador estricto de máximos y mínimos.
     * Funciona también con campos de moneda tipo: 456.456,00 €
     */
    const limitarMinMax = ($input) => {
        const rawMax = $input.attr('max');
        const rawMin = $input.attr('min');

        const hasMax = rawMax !== undefined && rawMax !== "";
        const hasMin = rawMin !== undefined && rawMin !== "";

        if (!hasMax && !hasMin) return;

        if ($input.val() === undefined || $input.val() === null) return;
        if ($input.val().toString().trim() === "") return;

        let val = parseNumeroES($input.val());

        const max = hasMax ? parseNumeroES(rawMax) : null;
        const min = hasMin ? parseNumeroES(rawMin) : null;

        let changed = false;

        if (hasMax && val > max) {
            val = max;
            changed = true;
        }

        if (hasMin && val < min) {
            val = min;
            changed = true;
        }

        if (!changed) return;

        if ($input.closest('.calc-monto').length) {
            $input.val(formatMonedaES(val));
        } else {
            $input.val(val);
        }

        $input.trigger('change');
    };

    /**
     * Calcula la cuota mensual.
     */
    const calcularCuota = (P, r, n) => {
        if (n > 40) n = 40;

        if (P <= 0 || r <= 0 || n <= 0) return null;

        const i = r / 100 / 12;
        const m = n * 12;
        const factor = Math.pow(1 + i, m);
        const cuota = P * (i * factor) / (factor - 1);

        if (!isFinite(cuota)) return null;

        return {
            cuota,
            plazo: n
        };
    };

    /**
     * Limitador global.
     */
    $(document).on('input change blur', '.gfield input', function() {
        limitarMinMax($(this));
    });

    /**
     * Lógica visual en vivo para la Página 1.
     */
    const updateLiveView = () => {
        const $result = $('#live-result');

        // Busca primero por ID. Si no existe, busca el small dentro del bloque.
        const $detail = $('#live-result-detail').length
            ? $('#live-result-detail')
            : $('.live-calc-preview .preview-result-content small');

        if (!$result.length) return;

        const P = getVal('.calc-monto input');
        const r = getVal('.calc-interes input');
        const n = getVal('.calc-plazo input');

        const calculo = calcularCuota(P, r, n);

        if (calculo) {
            const format = calculo.cuota.toLocaleString('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            $result
                .html(`${format} € <em>/mes</em>`)
                .removeClass('is-calculating');

            if ($detail.length) {
                $detail.text(`Hipoteca a ${calculo.plazo} años calculada según tus datos`);
            }

            return;
        }

        const rawMonto = $('.calc-monto input').val() || "";
        const rawInteres = $('.calc-interes input').val() || "";
        const rawPlazo = $('.calc-plazo input').val() || "";

        if (
            rawMonto.toString().trim() !== "" ||
            rawInteres.toString().trim() !== "" ||
            rawPlazo.toString().trim() !== ""
        ) {
            $result
                .html("Calculando...")
                .addClass('is-calculating');

            if ($detail.length) {
                $detail.text("Completa los datos para ver tu cuota.");
            }
        } else {
            $result
                .html("")
                .removeClass('is-calculating');

            if ($detail.length) {
                $detail.text("Introduce los datos para calcular tu cuota.");
            }
        }
    };

    /**
     * Eventos de cálculo en página 1.
     */
    $(document).on('input change blur', '.calc-monto input, .calc-interes input, .calc-plazo input', function() {
        limitarMinMax($(this));
        updateLiveView();
    });

    /**
     * Gravity Forms render.
     */
    $(document).on('gform_post_render', function(event, form_id, current_page) {
        const $monto = $('.calc-monto input');
        const $interes = $('.calc-interes input');
        const $plazo = $('.calc-plazo input');

        if ($monto.length) limitarMinMax($monto);
        if ($interes.length) limitarMinMax($interes);
        if ($plazo.length) limitarMinMax($plazo);

        if (current_page === 1) {
            updateLiveView();
        } else if (current_page === 2) {
            const $resultadoVisual = $('#final-cuota-text');

            // Busca primero por ID. Si no existe, busca el small dentro del bloque final.
            const $detalleFinal = $('#final-result-detail').length
                ? $('#final-result-detail')
                : $('.final-result-content small');

            const $campoOculto = $('.calc-hidden-field input');

            if (!$resultadoVisual.length) return;

            const P = getVal('.calc-monto input');
            const r = getVal('.calc-interes input');
            const n = getVal('.calc-plazo input');

            const calculo = calcularCuota(P, r, n);

            if (calculo) {
                const finalValue = calculo.cuota.toLocaleString('es-ES', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) + " €";

                $resultadoVisual.html(`${finalValue} <em>/mes</em>`);

                if ($detalleFinal.length) {
                    $detalleFinal.text(`Hipoteca a ${calculo.plazo} años calculada según tus datos`);
                }

                if ($campoOculto.length) {
                    $campoOculto.val(finalValue).trigger('change');
                }
            } else {
                $resultadoVisual.html("Faltan datos");

                if ($detalleFinal.length) {
                    $detalleFinal.text("Vuelve atrás y completa los datos.");
                }
            }
        }
    });

    /**
     * Primer cálculo por si el formulario ya está renderizado al cargar.
     */
    updateLiveView();
};

/**
 * PUNTO DE ENTRADA ÚNICO
 */
document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initNavigation();
    initGravityForms();
    initHomeFormCards();
    initPreselectGravityRadio();
    initCalculadoraHipoteca();
    Fancybox.bind('[data-fancybox]', {});
});